export const ClickOutside = {
    bind  : (el, binding, vnode) => {
        el.event = event => !el.contains(event.target) && vnode.context.$emit('onClickOutside', event);
        document.body.addEventListener('click', el.event);
    },
    unbind: el => document.body.removeEventListener('click', el.event)
};